import { DownOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

/**
 * Бутонът за разгъване вдясно от реда с chips над каталога — показва/скрива
 * редовете след първия. Рендира се САМО при препълване (виж useChipRows).
 * Само иконка (стрелка, обръща се при разгънато), 38×38 с вида на къщичката;
 * текстът „Всички" е в подсказката.
 */
export function ExpandRowsButton({
  expanded,
  onToggle,
}: {
  expanded: boolean;
  onToggle: () => void;
}) {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-expanded={expanded}
      title={t("ordering.allRows")}
      aria-label={t("ordering.allRows")}
      className="w-[38px] h-[38px] shrink-0 rounded-[10px] border bg-pos-panel border-pos-line text-pos-dim grid place-items-center cursor-pointer transition-colors hover:border-pos-accent/40 mt-px"
    >
      <DownOutlined
        className={`text-base transition-transform ${expanded ? "rotate-180" : ""}`}
      />
    </button>
  );
}
